import { Type } from 'class-transformer';

export class FordIntegrationFetch {
  CustomerNumber: string;
  Desi: string;
  Dealer: string;
  ZerTrorCode: string;
  ZerTrorId: string;
  TrorEntryDateTime: string;
  DeparturePoint: string;
  DepartureCity: string;
  DepartureCounty: string;
  DepartureAddress: string;
  DestinationCity: string;
  DestinationCounty: string;
  DestinationAddress: string;
  ExpectedDeliveryDate: string;
  Extension: string | null;
  status?: string;
}

export class FordIntegrationParse {
  id: string;
  status: string;
}

export class IFordIntegrationFetchListResponse {
  @Type(() => FordIntegrationFetch)
  results: FordIntegrationFetch[];
}

export type IFordIntegrationParseListResponse = FordIntegrationParse[];

export class IFordIntegrationFetchQueryDto {
  startDate?: string;
  endDate?: string;
}
